
/*eslint-disable */

import VueGallery from 'vue-gallery'
import { bus } from '@/main';
import carousel from 'vue-owl-carousel'
import pdfViewer from './pdf-viewer';

const $ = window.jQuery = require('jquery');

export default {
  name: 'event-info',
  components: {
    carousel,
    'gallery': VueGallery,
    'pdf-viewer' : pdfViewer
  },
  props: [],
  data() {
    return {
      isSubmitted:false,
      galleryImages:[],
      index: null,
      evtInfo:null,
      pdfViewerPopup:false,
      pdfViewerUrl:'',
      pdfViewerFileName:''
    }
  },
  computed: {
  },
  mounted() {
    bus.$emit('showHeaderbtn', false);
    this.$store.dispatch('eventInfoByIdAction', {id:this.$route.params.evtId}).then((res) => {
      this.evtInfo = res.data.data
      this.galleryImages = this.evtInfo.events_gallery
      this.pdfViewerUrl = this.evtInfo.pdf 
      if(this.pdfViewerUrl){
        this.pdfViewerFileName = this.pdfViewerUrl.split('/')[5].split('?')[0]
      }
    })
    bus.$on('pdfViewerPopupBus', (data) => {
      this.pdfViewerPopup = data;
    });
  },
  methods: {
    pdfViewerFun(){
      this.pdfViewerPopup = true
      document.body.classList.remove('pdf_view_actv');
    },
    getImageListMethod(item){
      const arrImgs = item.map((value) => {
        return value.image;
      })
      return arrImgs; 
    }
  },
  watch: {
  },
  beforeCreate: function() {
    $('body').addClass('left_sidebaar_disabled_for_page')
    $('body').addClass('public_page_for_wrp_img')
  },
  beforeRouteLeave: function (to, from, next) {
    $('body').removeClass('left_sidebaar_disabled_for_page')
    $('body').removeClass('public_page_for_wrp_img')
    $(window).scrollTop(0);
    next();
  },
}